import { Keyboard } from "@capacitor/keyboard";
import { Capacitor } from "@capacitor/core";
import { useEffect, useState } from "react";

export function useIsKeyboardOpen(): boolean {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (!Capacitor.isNativePlatform()) return;

    const showHandle = Keyboard.addListener("keyboardWillShow", () => setIsOpen(true));
    const hideHandle = Keyboard.addListener("keyboardWillHide", () => setIsOpen(false));

    return () => {
      showHandle.then((h) => h.remove());
      hideHandle.then((h) => h.remove());
    };
  }, []);

  return isOpen;
}
